import { generatePath } from 'react-router-dom'

export const pathStandaloneSteps = (basePath: string) => `${basePath}/standalone-steps`
export const urlStandaloneSteps = (basePath: string) => generatePath(pathStandaloneSteps(basePath))

export const pathStandaloneStepAddWholesaler = (basePath: string) => `${basePath}/add-wholesaler/:wholesalerUUID`
export const urlStandaloneStepAddWholesaler = (basePath: string, wholesalerUUID: string) =>
  generatePath(pathStandaloneStepAddWholesaler(pathStandaloneSteps(basePath)), { wholesalerUUID })
